"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const useDeepMemo_1 = require("../../../hooks/useDeepMemo");
const theme_1 = require("../../../theme");
const BarChart_1 = __importDefault(require("../BarChart"));
exports.default = ({ voyages }) => {
    const monthlyVoyages = (0, useDeepMemo_1.useDeepMemo)(() => {
        const groupedByMonth = voyages.reduce((result, voyage) => {
            const voyageDate = new Date(voyage.end_date || voyage.start_date);
            if (isNaN(voyageDate.getTime())) {
                return result;
            }
            const month = `${voyageDate.getMonth() + 1}`.padStart(2, "0");
            const key = `${voyageDate.getFullYear()}-${month}`;
            return {
                ...result,
                [key]: (result[key] ?? 0) + 1,
            };
        }, {});
        return Object.keys(groupedByMonth)
            .sort()
            .map((x) => ({ x, value: groupedByMonth[x] }));
    }, [voyages]);
    return ((0, jsx_runtime_1.jsx)(BarChart_1.default, { title: "Voyages by month", unit: "voyages", data: [
            {
                name: "Voyages",
                color: theme_1.theme.colors.blue,
                data: monthlyVoyages,
            },
        ] }));
};
